import React from 'react';

import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {toggleCaliforniaPrepositionPopup} from '../../store/reducers/showCaliforniaPrepositionPopup/showCaliforniaPrepositionPopup';
import {isCaliforniaStateSelected} from '../../store/selectors/deliveryStep/deliveryStep';

import s from './californiaPrepositionNotice.scss';

export type PropsType = {
    isShippingAddressCalifornia: boolean;
    toggleCaliforniaPopup: () => void;
};

/**
 * California Proposition Notice
 *
 * @constructor
 */
export const CaliforniaPrepositionNotice: React.FC<PropsType> = ({
    isShippingAddressCalifornia,
    toggleCaliforniaPopup,
}) =>
    isShippingAddressCalifornia ? (
        <div className={s.container}>
            <button className={s.link} onClick={toggleCaliforniaPopup} type="button">
                California Proposition 65 Warning
            </button>
        </div>
    ) : null;

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    isShippingAddressCalifornia: isCaliforniaStateSelected(state),
});

const mapDispatchToProps = {
    toggleCaliforniaPopup: toggleCaliforniaPrepositionPopup,
};

export const CaliforniaPrepositionNoticeConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CaliforniaPrepositionNotice);
